import { t } from '../i18n';

export function formatPlanLabel(label: string): string {
  const labels: Record<string, string> = {
    Free: t('plan_free'),
    Starter: 'Starter',
    Professional: 'Professional',
  };

  return labels[label] || label;
}

export function formatFeatureLabel(key: string): string {
  const labels: Record<string, string> = {
    pdf: 'PDF',
    zugferd: t('zugferd'),
    xrechnung: t('xrechnung'),
    email_delivery: t('feature_email_delivery'),
    credit_notes: t('feature_credit_notes'),
    cancellations: t('feature_cancellations'),
    vat_validation: t('feature_vat_validation'),
    automation: t('feature_automation'),
    priority_support: t('feature_priority_support'),
  };

  return labels[key] || key.replace(/_/g, ' ');
}
